import React from "react";
import { Route, Routes, BrowserRouter, useLocation } from "react-router-dom";
import { GoogleAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult, signOut } from 'firebase/auth';
import ReactGA from 'react-ga4';
import { auth } from './Firebase/firebase';
import RouteClass from './Route.js'
import SplashPage from './views/SplashPage.js'
import CreateAccount from './views/CreateAccount.js'
import NotFound from './components/NotFound.js'

getRedirectResult(auth).catch(err => console.log(`getRedirectResult error: ${err}`));

function PageviewTracker() {
    const location = useLocation();
    React.useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: location.pathname });
    }, [location.pathname]);
    return null;
}

export default class TeamRouter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            signIn: this.googleSignIn,
            signOut: this.googleSignOut,
        }
    }

    googleSignIn = () => {
        console.log("signing in")
        const provider = new GoogleAuthProvider();
        return signInWithPopup(auth, provider).catch(err => {
            console.log(`signInWithPopup failed (${err && err.code}); falling back to redirect.`);
            return signInWithRedirect(auth, provider);
        });
    }

    googleSignOut = () => {
        return signOut(auth).then(function() {
          console.log("User signed out.")
        }).catch(function(error) {
          console.log("User could not be signed out.")
        });
    }

    render() {
        return (
            <BrowserRouter>
                <PageviewTracker />
                <Routes>
                    <Route path="/createaccount" element={<CreateAccount {...this.state} {...this.props} />} />
                    <Route path="/:team/*" element={<RouteClass {...this.state} {...this.props} />} />
                    <Route path="/" element={<SplashPage {...this.state} {...this.props} />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        );
    }
};
